import { useBFF } from '~/composables/useBFF/useBFF';

export const usePageLoader = (key: string) => {
  const { $magnolia } = useBFF();

  const loading = ref(false);
  const content = useState(`pageloader-content-${key}`);
  const templateAnnotations = useState(`pageloader-templateAnnotations-${key}`);
  const errorContent = useState('pageloader-errorContent');
  const error = useState('pageloader-error', () => ({
    content: false,
    header: false,
    preFooter: false,
    footer: false,
  }));

  const header = useState('pageloader-header');
  const preFooter = useState('pageloader-preFooter');
  const footer = useState('pageloader-footer');

  const getErrorContent = async () => {
    const { data } = await $magnolia.fetchContent(`/404`);

    if (!data?.area1?.[0]?.content) {
      throw new Error('Error fetching 404 content');
    }

    errorContent.value = data;
  };

  const fetchContent = async (url: string) => {
    loading.value = true;
    error.value.content = false;
    try {
      const { data } = await $magnolia.fetchContent(url);

      content.value = data;
    }
    catch {
      error.value.content = true;
      showError({ statusCode: 404 });
    }
    finally {
      loading.value = false;
    }
  };
  const fetchTemplateAnnotations = async (url: string) => {
    loading.value = true;
    error.value.content = false;
    try {
      const { data } = await $magnolia.fetchTemplateAnnotations(url);
      templateAnnotations.value = data;
    }
    catch (err: any) {
      error.value.content = err?.message ?? true;
    }
    finally {
      loading.value = false;
    }
  };

  const getHeader = async () => {
    try {
      const url = `/header`;

      const { data } = await $magnolia.fetchContent(url);
      header.value = data;
    }
    catch {
      header.value = undefined;
      error.value.header = true;
    }
  };

  const getPreFooter = async () => {
    try {
      const url = `/prefooter`;

      const { data } = await $magnolia.fetchContent(url);
      preFooter.value = data;
    }
    catch {
      preFooter.value = undefined;
      error.value.preFooter = true;
    }

    return preFooter.value;
  };

  const getFooter = async () => {
    try {
      const url = `/footer`;

      const { data } = await $magnolia.fetchContent(url);
      footer.value = data;
    }
    catch {
      footer.value = undefined;
      error.value.footer = true;
    }

    return footer.value;
  };

  return {
    content: computed(() => content.value),
    templateAnnotations: computed(() => templateAnnotations.value),
    errorContent: computed(() => errorContent.value),
    error: computed(() => error.value),
    loading: computed(() => loading.value),
    header: computed(() => header.value),
    preFooter: computed(() => preFooter.value),
    footer: computed(() => footer.value),

    getHeader,
    getPreFooter,
    getFooter,
    fetchContent,
    fetchTemplateAnnotations,
    getErrorContent,
  };
};
